import { apiSlice } from 'store/slices/api/api-slice';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        productActive: builder.mutation({
            query: (productId: string) => ({
                url: `/product/activate/` + productId,
                method: 'PATCH',
                header: {},
            }),
        }),
    }),
});

export const { useProductActiveMutation } = importTradeDataApiSlice;
